const initialState = {}

const updatedPlayerReservations = (playerReservations, pr) => {
  const index = playerReservations.findIndex(e => e.id == pr.id)
  return [
    ...playerReservations.slice(0, index), 
    pr,
    ...playerReservations.slice(index + 1, playerReservations.length)
  ]
}

const releasedPlayerReservations = (playerReservations, prId) => {
  const index = playerReservations.findIndex(e => e.id == prId)
  return [
    ...playerReservations.slice(0, index), 
    ...playerReservations.slice(index + 1, playerReservations.length)
  ]
}

const updatedPlayer = (playerReservations, payload) => {
  const index = playerReservations.findIndex(e => e.player_id == payload.id)
  const pr = {...playerReservations[index], name: payload.name, displayed_name: `${payload.name} - ${payload.phone}`}

  return [
    ...playerReservations.slice(0, index), 
    pr,
    ...playerReservations.slice(index + 1, playerReservations.length)
  ]
}

const appendedNotes = (notes, note) => {
  return [ note, ...notes ]
}

const updatedNotes = (notes, note) => {
  const index = notes.findIndex(n => n.id == note.id)
  return [
    ...notes.slice(0, index), 
    note,
    ...notes.slice(index + 1, notes.length)
  ]
}

const releasedNotes = (notes, noteId) => {
  const index = notes.findIndex(n => n.id == noteId)
  return [
    ...notes.slice(0, index), 
    ...notes.slice(index + 1, notes.length)
  ]
}

const updatedGame = (game, payload) => {
  return game.special_event || game.nickname || payload.fake ? {...game} : {...game,  displayed_name: `${payload.name} Reservation`}
}

const gameModal = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'GAME_MODAL.INIT':
      return {...state, gameId: payload.id, socketUrl: payload.socketUrl, alert: null, 
        transaction: null, payment: null, modalCalendar: null, isLoading: false}
    case 'GAME_MODAL.SET_LOADING':
      return {...state, isLoading: payload.isLoading}
    case 'GAME_MODAL.GAME_LOADED':
      return {...state, ...payload}
    case 'GAME_MODAL.CLEAR_GAME':
      return {}
    case 'GAME_MODAL.SHOW_ALERT':
      return {...state, alert: payload, isLoading: false}
    case 'GAME_MODAL.CLEAR_ALERT':
      if (_.isEmpty(state)) return state

      return {...state, alert: null}
    case 'GAME_MODAL.GAME_UPDATED':
      return {...state, ...payload, isLoading: false}
    case 'GAME_MODAL.PR_UPDATED':
      return {...state, player_reservations: updatedPlayerReservations(state.player_reservations, payload)}
    case 'GAME_MODAL.PR_DELETED':
      return {
        ...state,
        game: payload.game,
        player_reservations: releasedPlayerReservations(state.player_reservations, payload.id)
      }
    case 'GAME_MODAL.UPDATE_PLAYER':
      return {...state, player_reservations: updatedPlayer(state.player_reservations, payload), game: updatedGame(state.game, payload)}
    case 'GAME_MODAL.NOTE_CREATED':
      return {...state, notes: appendedNotes(state.notes, payload)}
    case 'GAME_MODAL.NOTE_EDITED':
      return {...state, notes: updatedNotes(state.notes, payload)}
    case 'GAME_MODAL.NOTE_DELETED':
      return {...state, notes: releasedNotes(state.notes, payload)}
    case 'GAME_MODAL.GAME_CANCELLED':
      return initialState
    case 'GAME_MODAL.GAME_CONFIRMED':
      return initialState
    case 'GAME_MODAL.SET_TRANSACTION':
      return {...state, transaction: payload}
    case 'GAME_MODAL.CANCEL_REFUND':
      return {...state, transaction: null}
    case 'GAME_MODAL.START_PAYMENT':
      return {...state, payment: payload}
    case 'GAME_MODAL.CLEAR_PAYMENT':
      return {...state, payment: null}
    case 'GAME_MODAL.CHANGE_RESERVATION':
      return {...state, modalCalendar: payload}
    case 'GAME_MODAL.CLOSE_CALENDAR':
      return {...state, modalCalendar: null}
    case 'GAME_MODAL.SET_EVENTS':
      return {...state, events: payload}
    case 'GAME_MODAL.SET_NOTES':
      return {...state, notes: payload}
    case 'GAME_MODAL.PAYMENT_LINKED':
      return {
        ...state,
        modalCalendar: null,
        player_reservations: updatedPlayerReservations(state.player_reservations, payload.player_reservation),
        alert: { 'text': 'Payment has been linked successfully', 'type': 'success' }
      }
    case 'GAME_MODAL.REFUNDED':
      return {
        ...state,
        game: payload.game,
        player_reservations: updatedPlayerReservations(state.player_reservations, payload.player_reservation),
        transaction: null
      }
    case 'GAME_MODAL.UPDATE_GAME':
      return {
        ...state,
        game: payload.game,
        player_reservations: payload.player_reservations,
        alert: { 'text': 'Game update success', 'type': 'success' } 
      }
    case 'PAYMENT_SUCCESS':
      if (_.isEmpty(state)) return state

      return {
        ...state,
        game: payload.game,
        player_reservations: updatedPlayerReservations(state.player_reservations, payload.player_reservation),
        transaction: null,
        payment: null,
        alert: { text: payload.message, type: 'success' }
      }
    }
  return state
}

export default gameModal
